import dayjs from "dayjs";
import { AD_LAYOUT_STUBS } from "@consts";
import { canonical } from "@utils";

const buildSpangramHints = (spangram) => {
	if (!spangram) {
		return [];
	}

	const numberOfVowels = spangram
		.split("")
		.filter((l) => /[aeiou]/i.test(l)).length;

	return [
		{
			indexLabel: "One",
			hint: `Today's “Spangram” has ${numberOfVowels} ${
				numberOfVowels === 1 ? "vowel" : "vowels"
			}`,
			visible: false,
		},
		{
			indexLabel: "Two",
			hint: `The length of Today’s NYT Strands “Spangram” is ${spangram.length} letters`,
			visible: false,
		},
		{
			indexLabel: "Three",
			hint: `Today’s “Spangram” begins with the letter ${spangram
				.substring(0, 1)
				.toUpperCase()}`,
			visible: false,
		},
	];
};

export default {
	name: "NYTStrands",
	data() {
		return {
			AD_LAYOUT_STUBS,
			today: dayjs(),
			answerVisible: false,
			spangramHints: null,
			todayPuzzle: null,
			pastPuzzles: null,
		};
	},
	async fetch() {
		const todayFormatted = dayjs().format("YYYY-MM-DD");
		if (process.server) {
			this.serverDateParam = todayFormatted;
		}

		await this.loadPuzzleData();
	},

	mounted() {
		if (this.serverDateParam) {
			const clientDateParam = dayjs().format("YYYY-MM-DD");
			if (clientDateParam !== this.serverDateParam) {
				this.$fetch();
			}
		}
	},
	head() {
		return {
			title: `NYT Strands Answers & Hints for Today (${
				this.currentDateString
			}) - ${this.getPuzzleIdDisplay(this.todayPuzzle?.id)}`,
			meta: [
				{
					name: "description",
					hid: "description",
					content:
						"Stuck on NYT Strands? Get daily hints, tips, and all the answers you need to untangle today’s puzzle. Including an archive with all the past games.",
				},
			],
			link: [canonical(this.$route)],
		};
	},
	computed: {
		currentDateString() {
			return dayjs().format("MMMM DD, YYYY");
		},
		pastPuzzlesData() {
			if (!this.pastPuzzles) {
				return [];
			}

			return Object.entries(this.pastPuzzles).map(
				([yearMonth, group]) => {
					const dummyDate = dayjs(`${yearMonth}-01`);
					const groupLabel = `NYT Strands ${dummyDate.format(
						"MMMM YYYY"
					)} Answers`;

					const entries = group.map(
						({ printDate, id, spangram, themeWords }) => {
							const dateLabel =
								dayjs(printDate).format("MMMM DD, YYYY");
							const entryLabel = `${dateLabel} #${id}`;

							return {
								printDate,
								entryLabel,
								spangram,
								themeWords,
							};
						}
					);

					return {
						yearMonth,
						groupLabel,
						entries,
					};
				}
			);
		},
	},
	methods: {
		getPuzzleIdDisplay(id) {
			return id ? `#${id}` : "";
		},
		loadPuzzleData(date = null) {
			const todayFormatted = date || dayjs().format("YYYY-MM-DD");
			const response = this.$axios.get(
				`${this.$config.API_SERVICE}/v3/nyt-strands?date=${todayFormatted}`
			);
			response
				.then(({ data }) => {
					const { todayPuzzle, pastPuzzles } = data || {};

					const spangram = todayPuzzle?.spangram || "";
					this.spangramHints = buildSpangramHints(spangram);
					if (todayPuzzle && pastPuzzles) {
						this.todayPuzzle = todayPuzzle;
						this.pastPuzzles = pastPuzzles;
					} else {
						this.$error({
							statusCode: 500,
						});
					}
				})
				.catch((err) => {
					this.$store.commit(
						"error/setStatusCode",
						err?.response?.status || 500
					);
				});
			return response;
		},
	},
};
